import $ from 'jquery';
import {Cookie} from "../utilities";

$('body').on('click','.js-auth-bonus-page',function (){
    Cookie.set('AUTH_BONUS_PAGE', '1', false);
})
